var _title, _path, _rect, _path2, _path3, _path4, _path5, _ellipse, _line, _path6, _polygon, _line2, _line3, _rect2, _line4, _line5, _path7, _path8, _path9, _line6, _path10, _polyline, _path11, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _polygon8, _path26, _path27, _path28, _line7, _path29, _line8, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _polygon9, _path54, _path55, _path56, _path57, _path58, _ellipse2, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _line9, _line10, _line11, _path85, _path86, _path87, _circle, _path88, _line12, _line13, _line14, _line15;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgModifyTripWithPet = function SvgModifyTripWithPet(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 240 170",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Early Check In")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M152.2,11.9c-58,10.3-27.9,18.6-118.1,21.7C-19.5,35.5,2,147.2,54.9,147.6c55.7.3,80.8.9,94,.6,65.5-1.7,81.1-37.9,87.3-70C241.6,50,221.1-.4,152.2,11.9Z",
    fill: "#fff4d0"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 116.2,
    y: 39.4,
    width: 59,
    height: 57.15,
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M107.7,55.7s.4-2.2,5.9-.8c3.6.9,4.6,6,3.1,9.4s-1.4,4.5-1.3,5.1c.8,4.7-4.1,3.8-6.1,2.9,0,0,.7-4.5-1.3-4.5s-1.9-3-1.9-4.5.9-2.9.9-4.7A4.6,4.6,0,0,1,107.7,55.7Z",
    fill: "#c68053"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M116.2,60.6c-1.6-1.5-3.9-3.4-5.8-1.7-.1.2.5.5,1,.5s-.5.3-.7.5.5.1.2.4h.2l-.2.8s-1.6.3-1.5-2.5a4.1,4.1,0,0,0-.1-1.2C112.1,57.4,115.6,57.5,116.2,60.6Z",
    fill: "#395c6e"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M110.4,58.9c1.9-1.7,4.2.2,5.8,1.7-.6-3.1-4.1-3.2-6.9-3.2a2.3,2.3,0,0,0-1.6-2,5.4,5.4,0,0,1,7.1-1.2c6.7,3.6.6,12.8.6,12.8-3.7,0-2.6-3.6-2.6-3.6s2.1-3.2.8-4.1-2.1.2-2.5,1h-.2c.3-.3-.3-.3-.2-.4s.7-.2.7-.5-1.1-.3-1-.5",
    fill: "#003449"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M108.4,55.8s-2.9-1.5-1.4-2.4,1.8,1.5,2.1-.5,3.5.7,2.9-.5,1.9-.6,2.9,0,1,3,2,3.1,3.2,3.8.5,7.1c0,0,0-6.5-3.4-6.6S108.4,55.8,108.4,55.8Z",
    fill: "#003449"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 106.5,
    cy: 59.8,
    rx: 1.1,
    ry: 2,
    fill: "none",
    stroke: "#fdd058",
    strokeMiterlimit: 10,
    strokeWidth: 0.35
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 111.2,
    y1: 60.2,
    x2: 107.6,
    y2: 59.8,
    fill: "none",
    stroke: "#fdd058",
    strokeMiterlimit: 10,
    strokeWidth: 0.35
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M110.5,65.5s-2,1.9-3.5,2c0,0,1.9.3,2.1,1.2s.3.6.3.6Z",
    fill: "#c27342"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "98.4 148.1 98.4 32.6 30 32.6 30 148.2 98.4 148.1",
    fill: "#fff"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 142.6,
    y1: 147.8,
    x2: 142.6,
    y2: 13.7,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.74
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 168.8,
    y1: 146.3,
    x2: 168.8,
    y2: 9.7,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.74
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 122.8,
    y: 46,
    width: 45.9,
    height: 43.96,
    fill: "#fff4d0",
    stroke: "#e2e6ec",
    strokeMiterlimit: 10,
    strokeWidth: 5.5
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 145.1,
    y1: 46,
    x2: 145.1,
    y2: 89.9,
    fill: "none",
    stroke: "#e2e6ec",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5.18
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 15.9,
    y1: 40,
    x2: 15.9,
    y2: 122.3,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.74
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M169.1,92.5s-5.7-13.4-10-14l3,14.1,4.9,5.7Z",
    fill: "#98aab6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M169.6,81.6s-.7-5.3.4-5,3.5,4.3,3,5.6a23.6,23.6,0,0,1-1.9,3.2L170,88.7l-2-2.6s1-4.9,1.9-6S169.6,81.6,169.6,81.6Z",
    fill: "#f7d5be"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M169.5,84.1c-1.4.3-1.4.8-1.4.9a47.2,47.2,0,0,0-1.6,11.9c0,2.3,2.3,1.9,3.6,1.1s1.7-9.3,2-14.1C172.1,83.7,170.8,83.8,169.5,84.1Z",
    fill: "#bbc7d0"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 167.9,
    y1: 86.1,
    x2: 171.9,
    y2: 85.6,
    fill: "none",
    stroke: "#98aab6",
    strokeMiterlimit: 10,
    strokeWidth: 0.51
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M158.2,77.4c.8.2,3.9,1.6,4.3,4.5s.5,5.7.5,5.7Z",
    fill: "#395c6e"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "37.5 148.4 91.2 148.4 91.2 39.3 37.5 39",
    fill: "#fff4d0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M112.5,106.7a122.3,122.3,0,0,0,5.8,39.6l3.2.7.8,1.2s-7.2,2.1-6.9,3.8,12.1-.4,12.1-.4a10.4,10.4,0,0,0-2.2-6.1l2.7-.9-5.6-19.2,4.4-19Z",
    fill: "#003449"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "37.5 39 84 47.8 84 139.9 37.5 148.4 37.5 39",
    fill: "#fbde8b"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "43.1 45.7 78.4 52.4 78.4 135.2 43.1 141.7 43.1 45.7",
    fill: "#98aab6"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "79.1 69.1 41.9 63.5 41.9 70.7 79.3 75.6 79.1 69.1",
    fill: "#fbde8b"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "79.1 89.4 41.9 87.5 41.9 94.8 79.3 95.9 79.1 89.4",
    fill: "#fbde8b"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "79.1 111.8 41.9 114.4 41.9 121.7 79.3 118.4 79.1 111.8",
    fill: "#fbde8b"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "82.3 89.9 79.8 89.6 79.8 98.6 82.3 98.5 82.3 89.9",
    fill: "#e2e6ec"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5,144.7s-1.5,5.1,2.4,6.6,1.5,2.1,3.8,2,.6-1-.1-1.2-5-4.7-2.3-7.6-4.3.3-4.3.3",
    fill: "#bbc7d0"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M39,141.9s-2.9,5.8-2,11.3a8.9,8.9,0,0,1-1.4,3.8c-1.2,1.6.3,2.5.8,1.1s.6-2.4,1.3-2.9,4.1-8.6,5.9-7.7S39,141.9,39,141.9Z",
    fill: "#bbc7d0"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7,152.9a3.1,3.1,0,0,0,1.7-.4,6.3,6.3,0,0,1-1.9.3Z",
    fill: "#fdd058"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1,153.4a1.4,1.4,0,0,1,1.1-.5h-.1A1.4,1.4,0,0,0,34.1,153.4Z",
    fill: "#fdd058"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M65.3,135c.4-.7-.1-2.3-.1-2.3a3.9,3.9,0,0,0-2.2-.4c-.8.1.7-1.9-3.6-2-1.3-.1-4.7,3.6-5.4,5.1s-1.6,1.1-8,1.9-7.4,4.9-8.5,7.4h-.1s-.3,1.3.8,1.3.3-1.6.6,1.4c.6,4.8,2.3,1.5,4,7.4,1.1,3.7-.6,2.2.4,3.9s2.8.3,1.9-.2-.4-3.4-.5-4.8a6.2,6.2,0,0,1,1.1-4c4.4-6.4,7-.8,11.1-3.7,0,0,.8.5.8,1,0,2.3-1.6-.8-2.5,2s1.8-.4,1.8-.4,3,.3,3.7-.6-1.6-5.4-1.6-5.6,1.8-5.4,1.8-5.4,1.2-1.1,2-1.1A4,4,0,0,0,65.3,135Z",
    fill: "#e2e6ec"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2,152.9h0Z",
    fill: "#bc6734"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4,152.5a2,2,0,0,0,1.3-1.6v-.5A3.8,3.8,0,0,1,37.4,152.5Z",
    fill: "#bc6734"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1,145.4c-.2-1.1-.9,0-.9,0l-.5-1a13.5,13.5,0,0,0-.9,2.8c-.1,1.3.7,3-1.9,4.4s-.8,4.5-.8,4.5A3.7,3.7,0,0,1,35,154a1.1,1.1,0,0,1,.9-.5h.5l1.8-.4a3.1,3.1,0,0,0,1.3-2A29.3,29.3,0,0,0,39.1,145.4Z",
    fill: "#bc6734"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3,131.2a5.1,5.1,0,0,0-3.8-1.5c-2.1.3-1.8-1-2.9-.1s1.1,2.7,2.8,2.5a4.4,4.4,0,0,1,3,.6s1.4.3,1-.1S60.3,131.2,60.3,131.2Z",
    fill: "#bc6734"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M54.1,135s4.7,0,6.2,3.3l-.7,1.5s-.8-3.2-6.1-3.6Z",
    fill: "#abc4cd"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M109.1,99.1s-12.1,23.6-12.6,24,5.5,23.2,5.5,23.2l2.5-.8.9,2.5c.5,3.1-6.5,6-5.3,8.7s12.3-4.9,12.3-4.9c0-2.2-.6-4.1-2.8-5.3l-.8-2.4,2-.8s-4.5-13.1-3.4-18.6,12.8-11.5,14.3-17.5S109.1,99.1,109.1,99.1Z",
    fill: "#395c6e"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M109.1,71.9c0-.3,5.6-5.1,8-3.6s1.7,2.3,2.4,4.6Z",
    fill: "#bbc7d0"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M127.4,106.7a192.9,192.9,0,0,1-3.3-22.1c-.9-13.9-5.9-28.6-16.5-11.2-4.8,7.8-8.7,13.5-8.7,13.5s-23.7,8.9-11.8,8.7c14.6-.2,18.5-8.7,18.5-8.7L103,108.1c3.2,1.7,16.4,3.6,19.7,2.5a14.9,14.9,0,0,0,4.2-2.2S127.6,108.3,127.4,106.7Z",
    fill: "#bbc7d0"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M111.3,70.7s4.8.9,5.1,2.2.8,18.2.8,19.5.5,7,4.4,7.4,9-1.8,9.2-3.3.2-7.4.2-7.4l-3.1-2.6S126,74,123.1,73.1a38.1,38.1,0,0,1-5.9-2.4S112.9,69.4,111.3,70.7Z",
    fill: "#003449"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "117.2 93.5 111.3 90.2 110.7 92.1 117.7 94.8 117.2 93.5",
    fill: "#003449"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M113.7,71.5s-3.7-2-5.1,1.9-1,16-1,16l-.6.5a27.5,27.5,0,0,0,5.2,4.4,20.3,20.3,0,0,0,3.4-10.7C116.1,73.9,113.7,71.5,113.7,71.5Z",
    fill: "#e2e6ec"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M78.8,95.4,82,91.9l4.2.7s-1.5,2.2.9,3c0,0-3.7,1.1-5.7-.4C81.4,95.2,79.2,97.4,78.8,95.4Z",
    fill: "#c68053"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M122,72.7l-.6-1.8s4.8,6.2,4.3,6.4-4.3-1.5-4.3-2.2A11.5,11.5,0,0,1,122,72.7Z",
    fill: "#003449"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 101.6,
    y1: 144.6,
    x2: 110,
    y2: 141.5,
    fill: "none",
    stroke: "#003449",
    strokeMiterlimit: 10,
    strokeWidth: 0.79
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M110.6,110.2s-10.5,9.9-8.5,18.3l3.3,14.4",
    fill: "none",
    stroke: "#003449",
    strokeMiterlimit: 10,
    strokeWidth: 0.79
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 114.7,
    y1: 110.8,
    x2: 116,
    y2: 115.1,
    fill: "none",
    stroke: "#003449",
    strokeMiterlimit: 10,
    strokeWidth: 0.79
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M119.1,86.9c-1.3-5.3-1.8-18.8-9.6-16.3,0,0-3.6.2-8.3,19.9-3.8,16,4.8,17.8,4.8,17.8s5.2,2.8,8.7,1.5,10.2-7.3,11.3-9.8S120.3,92.3,119.1,86.9Zm-1.9,3.5c-1.7,1.1-1.3,5.8-3.2,4.9a1.8,1.8,0,0,0-2.6.9c-3-3.1-8.7-1.4-8.7-1.4.8-15.9,6.9-23.2,6.9-23.2,5.2-3,6.9,7.5,6.9,7.5S118.9,89.3,117.2,90.4Z",
    fill: "#fdd058"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M104.8,97.5l-.9,6.3s-.5,1.3,1.2,1.9a54.6,54.6,0,0,0,5.5,1.4s1.8.4,1.8-1.1-.4-7-.4-7Z",
    fill: "#fbde8b",
    stroke: "#fdd058",
    strokeMiterlimit: 10,
    strokeWidth: 0.68
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M104.2,95.7s-.9,3.4.7,3.7,6.2,1.8,6.2,1.8,2,.9,1.7-1.2l-.4-2.1Z",
    fill: "#fbde8b",
    stroke: "#fdd058",
    strokeMiterlimit: 10,
    strokeWidth: 0.68
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M116.1,97.8l2.2,5.1s.8,1.5,1.9.7a32.9,32.9,0,0,0,3.4-3.5s1.4-1.2.5-2.3l-3.2-3.5Z",
    fill: "#fbde8b",
    stroke: "#fdd058",
    strokeMiterlimit: 10,
    strokeWidth: 0.68
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M115.5,97l.3,1.5s.6,1.3,1.5.7l4.6-3.2a1.3,1.3,0,0,0,.1-2l-1.1-1.1Z",
    fill: "#fbde8b",
    stroke: "#fdd058",
    strokeMiterlimit: 10,
    strokeWidth: 0.68
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M95,101.9c-.4-.5-1.1-1-1.7-1.6s-4.3,3.7-3.9,5.4,2.7,1.5,2.7,1.5l3.4-4.2.5.2A4.1,4.1,0,0,1,95,101.9Z",
    fill: "#c68053"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M107,89.9,93.5,100.1s0,.1-.2.2,1.3,1.1,1.7,1.6a4.1,4.1,0,0,0,1,1.3l1.5.7s9.8-2.1,14.7-9.6A27.5,27.5,0,0,1,107,89.9Z",
    fill: "#e2e6ec"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M145.9,90.8c-.4.7.6,1.3.3,2a19.4,19.4,0,0,0-2.1,2.9c1.6-1.6,3-3.3,3-3.3h0c.2-1.4.5-2.8.7-4.3C147.5,89.5,146.8,89.8,145.9,90.8Z",
    fill: "#98aab6"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M159,78c-7.4-5.9-12.1.8-12.1.8s-4.7,7.5-5.1,8.6-5,5.6-4.6,8.2,4.5,2.5,6,1l.9-.9a19.4,19.4,0,0,1,2.1-2.9c.3-.7-.7-1.3-.3-2s1.6-1.3,1.9-2.6c-.2,1.5-.5,2.9-.7,4.3L145.8,116s6.6,2.8,8.6-.2,4.1-2.5,4.2-1.7,7.9,3.8,10.2,2.6C168.8,116.7,163.5,81.7,159,78Z",
    fill: "#bbc7d0"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M158.2,93.9V91.1l-3.4-.5c.1,1.2.2,2.4.2,3.8a16.6,16.6,0,0,1,3.2.3Z",
    fill: "#395c6e"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M155,94.4c.2,3,.3,6.3.3,9.5l3.2.4c-.1-2.9-.3-6.1-.3-9.6A16.6,16.6,0,0,0,155,94.4Z",
    fill: "#fffcf3"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M154.6,85.4c0,1.2.1,3,.2,5.2l3.4.5c-.1-2.1-.2-3.8-.3-5.3Z",
    fill: "#fffcf3"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M153.8,81.1l.7,2.8s0,.6.1,1.5l3.3.4q-.3-2.7-.6-4.2Z",
    fill: "#395c6e"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M153.2,78.8l.6,2.3,3.5.5c-.3-1.7-.5-2.4-.5-2.4a1.4,1.4,0,0,1-.3-.5Z",
    fill: "#fffcf3"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M153.7,76.5l-1.3-.3a16.5,16.5,0,0,1,.8,2.6h3.3C156,78,155,76.6,153.7,76.5Z",
    fill: "#395c6e"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M152.4,76.2a.4.4,0,0,0-.1-.3S152.2,76,152.4,76.2Z",
    fill: "#395c6e"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M153.2,116.5c-2.4,1.3-6.4-.1-6.4-.1s-4.8,16.1-1.8,26.5l2,.9a21,21,0,0,0,3.5.5C149.4,134.8,149.8,125.3,153.2,116.5Z",
    fill: "#f1bb9a"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M146.6,144.3l-.8.9s.9,4.2-1,4.7-4.2,2.6-2.9,2.8c3.1.4,7.4-1.3,9.4-2.3-.3-2-.6-4.1-.8-6.1Z",
    fill: "#99b7c5"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M176.5,140.3c-.5-2.8-1.9-9.9-5.4-15.2s-2.7-8.1-2.7-8.1c-3.2.1-8.9-2.1-9.1-2.9s-.7-9.8-1-15.6a10.6,10.6,0,0,0-3.1.2c.1,5,0,12.8-.5,15.7a14.2,14.2,0,0,0,2.5,2.4h.1s9.1,14.4,13.9,24.1A10.5,10.5,0,0,0,176.5,140.3Z",
    fill: "#f1bb9a"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M176.9,144.4a22.6,22.6,0,0,0-.2-3.3,8.9,8.9,0,0,1-4,.6.8.8,0,0,0-.7,1.1h0c.5,1.1-.8,2.6-3.5,5.2s4.9,4.8,7-.3S176.9,144.4,176.9,144.4Z",
    fill: "#99b7c5"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M151.3,150.4l1.2-.5s-.3-2.3-.4-5.6h-1.6C150.7,146.3,151,148.4,151.3,150.4Z",
    fill: "#75a2b2"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M157.2,116.8a14.2,14.2,0,0,1-2.5-2.4,4.1,4.1,0,0,1-.3,1,3.2,3.2,0,0,1-1.2,1.1c-3.4,8.8-3.8,18.3-2.7,27.8h1.6C151.7,136.1,151.8,121.5,157.2,116.8Z",
    fill: "#eea37a"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M148.1,85.3l2-1.3s1.2,2.1-.3,3S148.1,85.3,148.1,85.3Z",
    fill: "#f7d5be"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M159.5,78.8l-1.4,2.4,1.8,1.4s1.8,8.4-1.5,9.7",
    fill: "none",
    stroke: "#98aab6",
    strokeMiterlimit: 10,
    strokeWidth: 0.51
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    points: "161.7 100.6 165.8 101.2 166.9 110 162.4 109.4 161.7 100.6",
    fill: "none",
    stroke: "#98aab6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.51
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M150.7,79.9l2,1.8-1.2,1.5s.6,7.6,3.3,8.9",
    fill: "none",
    stroke: "#98aab6",
    strokeMiterlimit: 10,
    strokeWidth: 0.51
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M156.3,69.2s2.3,3.9,1.7,5.8-1.9,1.4-1.1,2.6-.3,1.4-.3,1.4-1.2-2.1-2.1-2.2S153.7,71.7,156.3,69.2Z",
    fill: "#c68053"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M155,65.6c.3.3,3.2-.1,3.2-.1s1.1,3.6.4,5.4-1.5,4-2.6,4-1.6-.6-1.4,1.8c0,0,3.1,2.8,1,2.9s-4-5.2-4-5.6,1.6-8.6,1.6-8.6Z",
    fill: "#f7d5be"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M153.4,100.3l-6.1,1.1-.2,8.7h6.1Z",
    fill: "none",
    stroke: "#98aab6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.51
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M146.9,78.8s2.6,3.9,2.2,7-2.9,9.3-2.8,11l.3,1.9,2.3-7.5s3.1-6.6,1.9-11.7Z",
    fill: "#395c6e"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 148.7,
    cy: 60.4,
    rx: 1.4,
    ry: 1.3,
    fill: "#eea37a"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M150.7,82.6c1.2.7.5,2.3-.9,4.4l-4.1,4.4-1.6-2.3,1.6-1.7s0-3.3,1-3.9A7,7,0,0,1,150.7,82.6Z",
    fill: "#f7d5be"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M153.7,65.4s1.2,4.1-.9,5.4,1.1,3.5.9,4.9-.5.9-1.1,1.2a1.6,1.6,0,0,0-.8,2c.5,2.1-1.4,3.1-2.1,2.7-3.5-2-4-4-2.8-6.1s-1.2-3,.6-5.7,2.2-2.5,3.3-5.9Z",
    fill: "#c68053"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M148.8,68.7s-.7.7-1.1-.2a9.8,9.8,0,0,1-.5-2.6s.2-1.1,5.1-2.6,5.8.2,5.9.6a3.3,3.3,0,0,1,.2,2C158.2,66.4,156.4,64.1,148.8,68.7Z",
    fill: "#fdd058"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M147.6,66.2s-.4-1.5.3-2-.2-3.8,1.3-3.4,4.4-1,5.9.6,2.4,2.1,2.4,2.1Z",
    fill: "#fdd058"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M147.9,64.2a5.2,5.2,0,0,0,2.9-1.4",
    fill: "none",
    stroke: "#eea37a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.51
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M147.3,65.4a18,18,0,0,1,9.4-2.6",
    fill: "none",
    stroke: "#eea37a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.51
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M146.1,84.2l2.2-2.8s.6.5-.3,2.4S146.1,84.2,146.1,84.2Z",
    fill: "#f7d5be"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M165.5,116.4s5.2,8.4,11,23.9",
    fill: "none",
    stroke: "#eea37a",
    strokeMiterlimit: 10,
    strokeWidth: 0.74
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M184,138.9q.5-1.3.9-3.3a23.2,23.2,0,0,1-4.3-2.4l.2.2-.3,1.7C179.6,136.6,182.5,138.4,184,138.9Z",
    fill: "#98aab6"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M180.3,135.1c0-.2-.3-.1-.7,0l-.3,1.1s-5.4-1.9-5.9-1.4,6.7,7.2,9.3,6.8c.5,0,1.1-1,1.8-2.7C182.5,138.4,181.1,137.7,180.3,135.1Z",
    fill: "#003449"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M203.2,106.9c-14.5-3.4-14.8,13-16.2,25.6,3.6-9.6,8.9-23.6,15.4-23.8C203.1,107.8,203.7,107.1,203.2,106.9Z",
    fill: "#fdd058"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M215.5,141.1l-.8-32.4L188.8,99s-10.2,18.5-10.7,33.1l1.7,1.1c2,.9,3.9,2.4,6,2.9.3-.9.8-2.5,1.2-3.6,1.4-12.6,1.7-29,16.2-25.6.5.2-.1.9-.8,1.8h.2s-1.8,23.4,2.9,33.9h1.3Z",
    fill: "#fbde8b"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M212.9,143.7l-.2-2.3a42.6,42.6,0,0,0-5,.6v1C209.4,142.3,211.2,144.1,212.9,143.7Z",
    fill: "#98aab6"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M206.9,143v.8s-5.3,1.1-4.4,3.1c0,0,6.8.8,11.4-.8l-.3-2.4C211.5,144.1,209.1,142.3,206.9,143Z",
    fill: "#003449"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M209.9,68.7a11.7,11.7,0,0,1-2.1-2,17.1,17.1,0,0,1-8.5,4.5c-1,0-1.7,1.3-2.3,1.6s-2.5-.9-3.2-2.3c-2.3,5.8-8.4,25.1-8.8,31.1s29.4,7.8,29.7,7.1S219.6,71.9,209.9,68.7Z",
    fill: "#eea37a"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M198.3,66.5c-.2-.3-3,.6-4,3a9.3,9.3,0,0,0-.5,1c.7,1.4,2,2.7,3.2,2.3s1.3-1.6,2.3-1.6h.2a20.9,20.9,0,0,1,.8-3.4Z",
    fill: "#e7824f"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M200.3,70.4s-3.1,1.9-3.1,9.1c0,0-4.1,5.6-3.8,9.4a11.5,11.5,0,0,0-2.1,8.7s-2.5,6.5-.4,9c0,0-3.1-1.2-3.7-2s3.6-21.8,8.8-32c0,0,.9-2.5,2.1-3.1s-.7.8,2.3.8C200.5,70.3,200.3,70.4,200.3,70.4Z",
    fill: "#6799aa"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M197.2,79.5c.8,0,8.3,1.2,8.3,1.2",
    fill: "none",
    stroke: "#e7824f",
    strokeMiterlimit: 10,
    strokeWidth: 0.79
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M193.2,88.7l13.9,1.6",
    fill: "none",
    stroke: "#e7824f",
    strokeMiterlimit: 10,
    strokeWidth: 0.79
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M191.1,97.6c.8,0,16.5,2.2,16.5,2.2",
    fill: "none",
    stroke: "#e7824f",
    strokeMiterlimit: 10,
    strokeWidth: 0.79
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M206,54.9c-2.1.2-6.4-1.5-8.6-.6,2,2.3,5.5-.5,7.1,1.1s0,2-1.3,2.7-1.3,1.9-.6,2.2,1.9-2.9,3.2-1.3,0,3,0,4.6a3.1,3.1,0,0,0,.7,1.4l.3-.4-.3.2C208.3,57.2,207.8,54.8,206,54.9Z",
    fill: "#bbc7d0"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M203.1,66.8c.6-.5,2.7-1.1,3.4-1.8a3.1,3.1,0,0,1-.7-1.4c0-1.6,1.7-3.3,0-4.6s-1.6,2.7-3.2,1.3,0-1.9.6-2.2,2-2.3,1.3-2.7-5.1,1.2-7.1-1.1c-.4.1-.7,1-.9,1.4s.3,1.9-.5,3-.7,7.1.3,8,2.1,2.8,1.8,3.2C201,71.4,201,69.7,203.1,66.8Z",
    fill: "#c68053"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M197.4,54.3s-.4-3,.8-2.7,1.5,1.3,2.6.9.9.3,1.6.5,1.1-.7,2-.1a15.2,15.2,0,0,1,2.4,2.7",
    fill: "#bbc7d0"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M206.8,64.6c-.1.1-5.4,2.1-6.5,3.1s-1.3,2.7-.8,3.4a16,16,0,0,0,8.3-4.4C208.2,66.2,207.5,64.3,206.8,64.6Z",
    fill: "#e7824f"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M205.1,73.6s-2.9,7.2-.5,12.4.3,22.8.3,22.8h9.8s7-24.6-3.3-32.1Z",
    fill: "#e98c5c"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M214.2,106.2s8.5-17-3-34.1a4.6,4.6,0,0,0-5.4,0c-1.5,1.1-2.3,5.5-1.1,8.9s5.9,10.2,5.9,10.2-1.9,10.6-2.7,14.8l4.1.5Z",
    fill: "#6799aa"
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 178.3,
    y1: 129.7,
    x2: 186.3,
    y2: 133.9,
    fill: "none",
    stroke: "#fdd058",
    strokeMiterlimit: 10,
    strokeWidth: 0.74
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 204.8,
    y1: 140.5,
    x2: 215.3,
    y2: 139.3,
    fill: "none",
    stroke: "#fdd058",
    strokeMiterlimit: 10,
    strokeWidth: 0.74
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 211.7,
    y1: 108.4,
    x2: 213.4,
    y2: 139.5,
    fill: "none",
    stroke: "#fdd058",
    strokeMiterlimit: 10,
    strokeWidth: 0.74
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M216.4,117.5l-4.1-8.6-1.1.7,4,8.4s.2.3-1.1.9a1.6,1.6,0,0,0-1.1,1.7s8,18.6,9.4,20.9,3.5,2.1,3.5,2.1l3.3-1.7L217.3,117Z",
    fill: "#003449"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M233.2,136.5s-7.8-18-10.2-19.9a4.6,4.6,0,0,0-3.8-.4L231,140.9l.8-.4C234,139.2,233.2,136.5,233.2,136.5Z",
    fill: "#003449"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M217.3,117l11.9,24.9,1.8-1-11.8-24.7Z",
    fill: "#bbc7d0"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 223.5,
    cy: 143.2,
    r: 2.5,
    fill: "#395c6e"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M207.9,106c0,.2-.1.3-.1.4a6.9,6.9,0,0,0,1.6,6.2s3.2-.1,3.5-2.1a5.7,5.7,0,0,0-1.3-3.9h.4Z",
    fill: "#c68053"
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 148.6,
    y1: 64.8,
    x2: 149.4,
    y2: 68.4,
    fill: "none",
    stroke: "#eea37a",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.51
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    x1: 150.9,
    y1: 63.8,
    x2: 151.6,
    y2: 67.2,
    fill: "none",
    stroke: "#eea37a",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.51
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    x1: 153.3,
    y1: 63.2,
    x2: 153.7,
    y2: 66.2,
    fill: "none",
    stroke: "#eea37a",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.51
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    x1: 155.9,
    y1: 62.7,
    x2: 156.4,
    y2: 65.8,
    fill: "none",
    stroke: "#eea37a",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.51
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgModifyTripWithPet, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/modify-trip-with-pet.34af1bad.svg";
export { ForwardRef as ReactComponent };